import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';

@Component({
  selector: 'ac-home-logo',
  templateUrl: './home-logo.component.html',
  styleUrls: ['./home-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, TranslateModule],
  hostDirectives: [RouterLink],
  standalone: true,
})
export class HomeLogoComponent {
  @HostBinding('attr.role') role = 'button';
  @HostBinding('attr.tabindex') tabIndex = 0;

  constructor(private _routerLink: RouterLink) {
    this._routerLink.routerLink = AcRoutingService.HOME_ROUTE();
  }
}
